import * as React from 'react'

interface IProps {
  style: React.CSSProperties
  level?: number
  defaultClassName?: string
}

export default class DeliveryCustomNodeWrapper extends React.Component<IProps> {
  public render() {
    const { style, children, level, defaultClassName } = this.props

    if (style) {
      style.marginLeft = 0
    }

    return (
      <div style={style} className={`row level-${level} ${defaultClassName}`}>
        {children}
      </div>
    )
  }
}
